export default function Tools() {
    return (
        <>
            <p>No virtual calculator is setup for this exam</p>
        </>
    );
}